<template>
  <el-row>
    <el-col :md="14">
      <s-table
        :showHeader="false"
        ref="drafts_dept"
        rowKeyField="id"
        :heightWish="null"
        :pagging="1000"
        vxmodel="relDrafts_depts"
        :allwaysEdit="true"
        xedit-disabled="disabled"
        :colDefinitions="colDefinitionsDepts"
        modx-processor="transdrafts/vuegetlist"
        :r-query="{start:0,limit:1,view:'acc_flat_routes',type:'dept',transctx:'out',route_id:routeData.id,sap_id:routeData.sapplierid}"
        :lazyLoader="false"
        :addEmptyLineIfEmpty="true"
        :row-class-factory="rowStyler"
        @cell-change="handleRelDraft($event,'dept')"
        @execute-row="handleRelDraft($event,'dept')"
        @cell-clicked="goTrans"
        :newRowData="{sap_id:routeData.sapplierid,rel_class:'Route',tags:routeData.destination,type:'dept',rel_object_id:routeData.id,isincome:false}"
      ></s-table>
    </el-col>
    <el-col :md="5">
      <s-table
        :showHeader="false"
        ref="drafts_payment"
        rowKeyField="id"
        :heightWish="null"
        :pagging="1000"
        vxmodel="relDrafts"
        :allwaysEdit="true"
        xedit-disabled="disabled"
        :colDefinitions="colDefinitionsPayments"
        modx-processor="transdrafts/vuegetlist"
        :r-query="{start:0,limit:1,view:'acc_flat_routes',transctx:'out',type:'payment',paymenttype:'bank',route_id:routeData.id,sap_id:routeData.sapplierid}"
        :lazyLoader="false"
        :addEmptyLineIfEmpty="true"
        :row-class-factory="rowStyler"
        @cell-change="handleRelDraft($event,'payment')"
        @execute-row="handleRelDraft($event,'payment')"
        @cell-clicked="goTrans"
        :newRowData="{sap_id:routeData.sapplierid,rel_class:'Route',tags:routeData.destination,paymenttype:'bank',type:'payment',rel_object_id:routeData.id,isincome:false}"
      ></s-table>
    </el-col>
    <el-col :md="5">
      <s-table
        :showHeader="false"
        ref="drafts_payment"
        rowKeyField="id"
        :heightWish="null"
        :pagging="1000"
        vxmodel="relDrafts"
        :allwaysEdit="true"
        xedit-disabled="disabled"
        :colDefinitions="colDefinitionsPayments"
        modx-processor="transdrafts/vuegetlist"
        :r-query="{start:0,limit:1,view:'acc_flat_routes',transctx:'out',type:'payment',paymenttype:'cash',route_id:routeData.id,sap_id:routeData.sapplierid}"
        :lazyLoader="false"
        :addEmptyLineIfEmpty="true"
        :row-class-factory="rowStyler"
        @cell-change="handleRelDraft($event,'payment')"
        @execute-row="handleRelDraft($event,'payment')"
        @cell-clicked="goTrans"
        :newRowData="{sap_id:routeData.sapplierid,rel_class:'Route',tags:routeData.destination,type:'payment',paymenttype:'cash',rel_object_id:routeData.id,isincome:false}"
      ></s-table>
    </el-col>
  </el-row>
</template>

<script>
import _ from "lodash";
import * as api from "~/api/resource";
import commons from "~/mixins/acc_commons";
import { mapActions, mapGetters } from "vuex";
export default {
  mixins: [commons],
  name: "routes-drafts",
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },

    routeData: {
      type: Object,
      default: () => {},
    },
    routeId: {
      default: null,
    },
  },
  data() {
    return {
      disabled: true,
      loaded: false,
      dialogVisible: false,
      updating: false,
      relDrafts: [],
      newRow: null,
      parentDraftId: null,
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY",
    };
  },
  watch: {
    "$route.query.selectedTrans": {
      handler(val, oldval) {
        if (val == oldval) return;
        // this.disabled = true;
        this.parentDraftId = val;
        this.dialogVisible = !!val;
      },
      immediate: true,
    },
    "TransDraft.id": {
      handler(val) {
        // if (!this.dialogVisible) return;
        if (!val) return;
        var dr = {};
        dr.exectime = "now";
        dr.time = "now";
        dr.businessId = this.TransDraft.businessId;
        dr.title = this.TransDraft.title;
        dr.isincome = this.TransDraft.isincome;
        dr.parentid = this.$route.query.selectedTrans;
        dr.in = this.$route.params.direction;
        dr.place = this.TransDraft.place;
        dr.tags = this.TransDraft.tags;
        this.newRow = dr;
        _log_("new val", this.newRow);
        this.$nextTick(() => {
          // this.$refs.drafts.appendTrackedData([
          //   { title: this.TransDraft.title }
          // ]);
          this.disabled = false;
        });
      },
      immediate: true,
    },
  },
  computed: {
    payMessage() {
      if (!this.TransDraft) return;
      var msg =
        "Δεν υπαρχει υπόλοιπο για αυτην την χρεωση (" +
        this.$theMoney(this.TransDraft.cost) +
        ")";

      const bl =
        parseFloat(this.TransDraft.cost) - parseFloat(this.TransDraft.balanse);
      if (bl > 0)
        msg =
          "Το υπολοιπο είναι <strong>" +
          this.$theMoney(bl) +
          "</strong> απο " +
          this.$theMoney(this.TransDraft.cost);

      return msg;
    },

    qrelDrafts() {
      // _log_(
      //   ">>$route.query.selectedTrans>>>",
      //   this.$route.query.selectedTrans
      // );
      if (this.$route.params.tripid)
        return {
          kind: "package",
          mode: "transdrafts",
          sort: "in",
          limit: 0,
          start: 0,
          tripid: this.$route.params.tripid,
        };
      else return null;
    },
    colDefinitionsPayments() {
      const vm = this;
      // _log_(">>>>>", this.invoiceData);

      return [
        // {
        //   prop: "type",
        //   width: "50px",
        //   label: "Type",
        //   formatter(val, colDefs, row) {
        //     return '<i aria-hidden="true" class="icon material-icons">shopping_cart</i>';
        //   }
        // },
        {
          prop: "paymenttype",
          width: "60px",
          // editable: true,
          label: "Payed as",
          formatter(val, colDefs, row) {
            if (row.cost < 0)
              return '<i class="material-icons">settings_backup_restore</i>';

            // if (row.type == "dept") return;
            // if (!val) val = "cash";
            switch (val) {
              case "bank":
                return '<i aria-hidden="true" title="Payed in bank" class="icon material-icons" >account_balance</i>';
                break;
              case "cash":
                return '<i aria-hidden="true" title="Payed in cash" class="icon material-icons" >pan_tool</i>';
                break;
              case "visa":
                return '<i aria-hidden="true" title="Payed by Visa" class="icon material-icons" >credit_card</i>';
                break;
              case "stock":
                return '<i class="material-icons" title="This is a stock">settings_backup_restore</i>';
                break;
              default:
                return "-";
                break;
            }

            return "-";
          },
          // editorcomponent: {
          //   is: "s-tag-select",
          //   allowAdd: false,
          //   placeholder: "Payed as",
          //   options: [
          //     { value: "cash", label: "CASH" },
          //     { value: "bank", label: "BANK" },
          //     { value: "other", label: "OTHER" },
          //     // { value: "stock", label: "Πιστοτικο" },
          //     { value: "visa", label: "VISA" }
          //   ]
          // }
        },
        // // { prop: "transactionId", width: "", editable: false, label: "id" },
        // {
        //   prop: "title",
        //   width: "",
        //   editable: true,
        //   placeholder: "What is about"
        // },

        {
          prop: "cost",

          editorcomponent: {
            placeholder: "Payed amount",
            formatgreek: false,
            is: "s-number",
          },
          xwidth: "120px",
          title: "Payed amount",
          editable: true,
          label: "Amount",
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        // {
        //   prop: "transactionId",
        //   width: "60px",
        //   label: "",
        //   onlyEditMode: true,
        //   editable: true,
        //   sortable: false,
        //   editorcomponentFactory(row) {
        //     return {
        //       is: "el-button",
        //       icon: "el-icon-top-right",
        //       type: "success",
        //       circle: true,
        //       disabled: !row.id,
        //       title: "Click here for full edit"
        //     };
        //   },
        //   formatter(val, colDefs, row) {
        //     return "-";
        //   }
        // }
      ];
    },
    colDefinitionsDepts() {
      const vm = this;
      // _log_(">>>>>", this.invoiceData);

      return [
        // {
        //   prop: "type",
        //   width: "50px",
        //   label: "Type",
        //   formatter(val, colDefs, row) {
        //     return '<i aria-hidden="true" class="icon material-icons">euro_symbol</i>';
        //   }
        // },

        {
          prop: "title",
          width: "",
          editable: true,
          title: "Write a comment",
          placeholder: "What is about",
        },

        {
          title: "Dept amount",
          prop: "cost",
          editorcomponent: {
            placeholder: "Dept amount",
            formatgreek: false,
            is: "s-number",
          },
          width: "150px",

          editable: true,

          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        // {
        //   prop: "transactionId",
        //   width: "60px",
        //   label: "",
        //   onlyEditMode: true,
        //   editable: true,
        //   sortable: false,
        //   editorcomponentFactory(row) {
        //     return {
        //       is: "el-button",
        //       icon: "el-icon-top-right",
        //       type: "success",
        //       circle: true,
        //       disabled: !row.id,
        //       title: "Click here for full edit"
        //     };
        //   },
        //   formatter(val, colDefs, row) {
        //     return "-";
        //   }
        // }
      ];
    },
    ...mapGetters({
      transactionConfiguration: "user/transactionConfiguration",
    }),
  },
  mounted() {
    this.loaded = true;

    // this.$nextTick(() => {
    //   this.$refs.drafts.appendTrackedData([{}]);
    // });
    // _log_("trans.ss.REMOUNT ii..", this.qrelDrafts);
  },
  methods: {
    rowStyler(r) {
      // r;
      if (r.row.cost == 0) return "row-note";
      return (
        "row-" +
        r.row.type +
        " " +
        (Math.abs(r.row.deptamound - r.row.balanse) <= 0.01
          ? "row-payed"
          : "") +
        " " +
        (r.row.exectime < 100 ? "row-freezed" : "")
      );
    },
    init() {},
    goTrans(e) {
      if (e.column.property == "transactionId") {
        if (!e.row.id) {
          return;
        }
        this.routeGo({
          name: "transaction",
          params: {
            transid: e.row.id,
            id: e.row.businessId,
            direction: "out",
            view: "contact",
          },
        });
      }
    },
    async handleRelDraft(data, type) {
      _log_("UPPPP..", data);
      // if (!this.TransDraft) return;
      var dr = data.row;
      dr.exectime = "now";
      dr.time = "now";
      // dr.businessId = this.TransDraft.businessId;
      // dr.isincome = this.TransDraft.isincome;

      // dr.parentid = this.$route.query.selectedTrans;
      // dr.in = this.$route.params.direction;
      // dr.place = this.TransDraft.place;
      // // dr.isicome = this.$route.params.direction == "in";
      // dr.type = "payment";
      //
      if (dr) {
        const isNew = !dr.id;
        var d = await api.updateProcessor("transdrafts/update", dr);
        _log_("UPPPP.IN.....", d);
        if (isNew && this.$refs["drafts_" + type])
          this.$refs["drafts_" + type].updateRow({ idx: dr.idx }, { id: d.id });
        // if (!isNew) this.$refs.drafts.updateRow(d);
        // else this.$refs.drafts.updateRow({ id: null }, d);
      }

      // this.routeGo({
      //   name: "contact",
      //   params: {
      //     id: this.workingBusiness.businessId
      //       ? this.workingBusiness.businessId
      //       : "all"
      //   }
      // });

      // Transdraft = {};
    },
    handleClose(done) {
      _log_("trans..B..");
      this.disabled = true;
      this.TransDraft = null;
      this.$emit("refresh");
      if (!done) {
        this.dialogVisible = false;
        return;
      }
      done();
    },
    handleTransctions(e) {
      // _log_("trans..B..", e);
    },
  },
};
</script>
